<template>
    <div class="transfer-reports">
        <div
            v-if="getApplicationSetting('kdv_personeel') === '1' && isAuthorized('administration', 'employee-planning', 'view')"
            class="row mx-0 mb-1 py-3 align-items-center"
        >
            <div class="d-grid col-12 col-md-6 pb-2 pb-md-0">
                <router-link
                    class="btn btn-secondary"
                    :to="'/transfer/reports/employee_week_overview'"
                >
                    Medewerkers weekoverzicht
                </router-link>
            </div>
            <div class="col">
                Weekoverzicht met diensten en beschikbare medewerkers per vestiging. Inclusief kind-leidster ratio.
            </div>
        </div>
        <div
            v-if="isAuthorized('administration', 'child-planning-mutations', 'view')"
            class="row mx-0 mb-1 py-3 align-items-center"
        >
            <div class="d-grid col-12 col-md-6 pb-2 pb-md-0">
                <router-link
                    class="btn btn-secondary"
                    :to="'/transfer/reports/child_planning_mutations'"
                >
                  Afmeldingen kinderen
                </router-link>
            </div>
            <div class="col">
                Overzicht van afmeldingen uit de Ouderapp met de opmerking van de verzorger, per dag.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransferReports',
}
</script>

<style scoped>
.row {
    background-color: rgba(0,0,0,.05);
}
</style>
